import request from './request';

const uri = 'rent/';

const rent = {
  get: (id = '', options) => request(uri + id, options),
  // post: (options) => request(uri, { method: 'POST', ...options }),
  put: (id, options) => request(uri + id + '/status', { method: 'PUT', ...options }),
};

export default rent;
